/* CTR B2 — Real Results tab switcher. */
(function () {
  function initRoot(root) {
    root.querySelectorAll('.ctr-b2-results').forEach(function (section) {
      var tabGroups = section.querySelectorAll('.ctr-b2-results__tabs');
      var contents = section.querySelectorAll('.ctr-b2-results__content');

      function activate(index) {
        tabGroups.forEach(function (group) {
          group.querySelectorAll('.ctr-b2-results__tab').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-index') === String(index));
          });
        });
        contents.forEach(function (c) {
          c.classList.toggle('is-active', c.getAttribute('data-index') === String(index));
        });
      }

      // duplicate tab groups (mobile shows one above card, desktop one inside panel)
      section.querySelectorAll('.ctr-b2-results__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-index'));
        });
      });

      activate(0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initRoot(document); });
  document.addEventListener('shopify:section:load', function (e) { initRoot(e.target); });
})();
